<template>
  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.99992 9.79517C2.36811 9.79517 2.66659 10.0781 2.66659 10.4271V12.9549C2.66659 13.1225 2.73682 13.2832 2.86185 13.4017C2.98687 13.5203 3.15644 13.5868 3.33325 13.5868H12.6666C12.8434 13.5868 13.013 13.5203 13.138 13.4017C13.263 13.2832 13.3333 13.1225 13.3333 12.9549V10.4271C13.3333 10.0781 13.6317 9.79517 13.9999 9.79517C14.3681 9.79517 14.6666 10.0781 14.6666 10.4271V12.9549C14.6666 13.4577 14.4559 13.9399 14.0808 14.2954C13.7057 14.651 13.197 14.8507 12.6666 14.8507H3.33325C2.80282 14.8507 2.29411 14.651 1.91904 14.2954C1.54397 13.9399 1.33325 13.4577 1.33325 12.9549V10.4271C1.33325 10.0781 1.63173 9.79517 1.99992 9.79517Z"
      fill="#3C50E0" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.5286 2.39695C7.78894 2.15016 8.21106 2.15016 8.4714 2.39695L11.8047 5.55667C12.0651 5.80346 12.0651 6.20358 11.8047 6.45037C11.5444 6.69716 11.1223 6.69716 10.8619 6.45037L8 3.7375L5.13807 6.45037C4.87772 6.69716 4.45561 6.69716 4.19526 6.45037C3.93491 6.20358 3.93491 5.80346 4.19526 5.55667L7.5286 2.39695Z"
      fill="#3C50E0" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.99992 2.21185C8.36811 2.21185 8.66659 2.49478 8.66659 2.8438V10.4271C8.66659 10.7761 8.36811 11.0591 7.99992 11.0591C7.63173 11.0591 7.33325 10.7761 7.33325 10.4271V2.8438C7.33325 2.49478 7.63173 2.21185 7.99992 2.21185Z"
      fill="#3C50E0" />
  </svg>
</template>
